// Home.jsx
import React from 'react';
import HeroSection from '../Components/HeroSection';
import { FoldingLogos } from '../Components/FoldingLogos';
import { Helmet } from "react-helmet";
import ServicesSection from '../Components/ServicesSection';
import { CodeBeams } from '../Components/CodeBeams';

const Services = () => {
  // Define the title and description variables
  const title = 'Delivering Bespoke Web Development Services';

  const description = (
    <>
      Explore a range of services designed to transform your digital presence. Specializing in WordPress, PHP, JavaScript, and SEO, I craft custom solutions that drive growth and set your brand apart online.
    </>
  );

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://plambech.dev/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://plambech.dev/services"
      }
    ]
  };

  return (
    <div>
    <Helmet>
      <title>Services | Plambech Development - WordPress & PHP Expert</title>
      <meta name="description" content="Discover services offered by freelance developer Rasmus Plambech: custom WordPress development, PHP programming, and tailored digital solutions." />
      <link rel="canonical" href="https://plambech.dev/services" />

      {/* Open Graph Tags */}
      <meta property="og:title" content="Services | Plambech Development - WordPress & PHP Expert" />
      <meta property="og:description" content="Discover services offered by freelance developer Rasmus Plambech: custom WordPress development, PHP programming, and tailored digital solutions." />
      <meta property="og:url" content="https://plambech.dev/services" />

      {/* Twitter Card Tags */}
      <meta name="twitter:title" content="Services | Plambech Development - WordPress & PHP Expert" />
      <meta name="twitter:description" content="Discover services offered by freelance developer Rasmus Plambech: custom WordPress development, PHP programming, and tailored digital solutions." />

      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>

      {/* Pass the variables as props to HeroSection */}
      <HeroSection
        title={title}
        description={description}
        buttonText="See my cases!"
        buttonLink="/portfolio"
      />
      <ServicesSection />
      <CodeBeams />
      <FoldingLogos />
    </div>
  );
};

export default Services;